import { PartitionModal } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { ReportingAccessLevels } from '../../../NonReact/constants/Permissions'
import { isVarNotEmpty } from '../../../NonReact/utils/GlobalFunctions'

/**
 * Maps each supported {@link ReportingAccessLevels} API string to its PartitionModal language bundle key.
 */
const PARTITION_LICENSED_FOR_LABEL_KEY_BY_VALUE: Partial<Record<ReportingAccessLevels, string>> = {
    [ReportingAccessLevels.NONE]: PartitionModal.PartitionModal_LicensedFor_None,
    [ReportingAccessLevels.LITE]: PartitionModal.PartitionModal_LicensedFor_AkixiLite,
    [ReportingAccessLevels.BLF]: PartitionModal.PartitionModal_LicensedFor_AkixiBLF,
    [ReportingAccessLevels.ONE]: PartitionModal.PartitionModal_LicensedFor_AkixiONE,
    [ReportingAccessLevels.ONE_THOUSAND]: PartitionModal.PartitionModal_LicensedFor_Akixi1000,
    [ReportingAccessLevels.ENTERPRISE]: PartitionModal.PartitionModal_LicensedFor_Enterprise,
    [ReportingAccessLevels.TWO_THOUSAND]: PartitionModal.PartitionModal_LicensedFor_Akixi2000,
    [ReportingAccessLevels.ESSENTIALS]: PartitionModal.PartitionModal_LicensedFor_Essentials,
    [ReportingAccessLevels.PROFESSIONAL]: PartitionModal.PartitionModal_LicensedFor_Professional,
    [ReportingAccessLevels.CALL_CENTRE_AGENT]: PartitionModal.PartitionModal_LicensedFor_CallCentreAgent,
    [ReportingAccessLevels.CALL_CENTRE_SUPERVISOR]: PartitionModal.PartitionModal_LicensedFor_CallCentreSupervisor
}

/**
 * Resolves the display label for a partition "Licensed for" select option.
 *
 * @param language - Language handler with {@link PartitionModal.NAME} loaded.
 * @param apiValue - Value stored in the form / API (e.g. {@link ReportingAccessLevels} enum value).
 * @returns Localised label, or the raw value when no bundle key exists.
 */
export const getPartitionLicensedForSelectLabel = (language: CLanguageHandler, apiValue: string): string => {
    const key: Definable<string> = PARTITION_LICENSED_FOR_LABEL_KEY_BY_VALUE[apiValue as ReportingAccessLevels]

    if (isVarNotEmpty(key)) return language.get(key)

    return apiValue
}
